import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Layout } from './Layout';

const Profile = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const displayName =
    [user?.first_name, user?.last_name].filter(Boolean).join(' ') ||
    user?.username ||
    user?.email ||
    'User';
  const initials =
    displayName
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map(part => part[0]?.toUpperCase())
      .join('') ||
    'U';

  return (
    <Layout onBack={() => navigate(-1)}>
      <div className="max-w-7xl mx-auto px-0 sm:px-6 lg:px-8 py-6 md:py-12">
        <div className="bg-white rounded-lg shadow-lg p-4 md:p-6">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6">Profile</h1>
          <div className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
              <div className="h-20 w-20 md:h-24 md:w-24 rounded-full border-4 border-primary-200 bg-gray-100 flex items-center justify-center text-xl md:text-2xl font-semibold text-gray-700 shrink-0">
                {initials}
              </div>
              <div className="min-w-0">
                <h2 className="text-xl md:text-2xl font-semibold text-gray-900 break-words">{displayName}</h2>
                <p className="text-gray-600 break-words">{user?.email}</p>
              </div>
            </div>
            <div className="mt-6">
              <h3 className="text-lg font-medium text-gray-900 mb-2">User Information</h3>
              <pre className="bg-gray-50 rounded-lg p-3 md:p-4 overflow-auto text-xs md:text-sm max-h-[50vh]">
                {JSON.stringify(user, null, 2)}
              </pre>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
